import { Breadcrumbs } from "@components-common/layouts";
import { FC } from "react";
import { observer } from "mobx-react";

export type PageHeaderProps = {
  title: string;
  breadcrumbs?: boolean;
};

export const PageHeader: FC<PageHeaderProps> = observer(
  (props: PageHeaderProps) => {
    const breadcrumbs = props.breadcrumbs ? <Breadcrumbs /> : <></>;
    return (
      <div className="">
        <div className="page-information">
          <h1>{props.title}</h1>
          {breadcrumbs}
          {props.breadcrumbs}
        </div>
      </div>
    );
  }
);
